










import Vue, { PropType } from 'vue'
import HiddenInput from '@/types/HiddenInput.interface'
import HiddenInputComponent from '@/components/HiddenInput.vue'
import Person, { PhoneType } from '@/types/Person.interface'
import { Phone } from '@/types/Person.interface'
export default Vue.extend({
    components: { 'hidden-input': HiddenInputComponent },
    props: {
        //  Indicates if the component is in editing mode
        readonly: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    data() {
        return { loading: null }
    },
    computed: {
        phoneItems(): HiddenInput[] {
            //  If no phones, return an empty array
            if (!this.person.phones) return []

            //  Create and array of PersonShowItem from the phone number
            const items = this.person.phones.map((x: Phone) => ({
                name: this.phoneType(x.type),
                label: this.phoneType(x.type),
                value: this.$options.filters.personPhone(x),
                validate: 'phone',
                mask: '(###) ###-####',
                filter: 'phone',
                buttons: [
                    {
                        icon: x.default ? 'bi-check-circle-fill' : 'bi-check-circle',
                        tooltip: `Set '${this.phoneType(x.type)}' to default`,
                        loading: x.id === this.loading?.id,
                        small: true,
                        callback: () => this.setDefault(x)
                    }
                ],
                callback: (val: string) => {
                    //  Update the phone
                    x.free_form_number = val

                    //  If the phone is set to default, sync it with phone_default prop
                    if (x.default) this.person.phone_default = x
                }
            }))

            //  Return the mapped items
            return items
        }
    },
    methods: {
        phoneType(type: PhoneType): string {
            //  Replace underscores with spaces
            let str = type.replace('_', ' ')

            //  Convert to propercase
            return str.toProperCase()
        },
        async setDefault(phone: Phone): Promise<void> {
            //  Start the loading spinner
            this.loading = phone

            //  Set all phone's default to false
            this.person.phones.forEach((x: Phone) => (x.default = false))

            //  Set this selected phone's default to true
            phone.default = true

            //  Update our phones
            await this.$store.dispatch('phoneNumbersPut', phone)

            //  Update the selected person's default phone
            this.person.phone_default = phone

            //  Stop the loading spinner
            this.loading = null
        }
    }
})
